import React from 'react';
import {Link} from "react-router-dom";

interface FooterProps {
    props?: unknown;
}

export default function Footer({props}: FooterProps) {

	return (
<footer className="section footer-classic">
    <div className="footer-classic-aside">
        <div className="container">
            <div className="row justify-content-left">
                <div className="col-sm-3 col-md-3 col-lg-3" style={{textAlign: 'left'}}>
                    <h4 >Products</h4>
                    <div>
                        <ul>
                            <li> 
                                <Link to="/technology-type">Web Technologies</Link>
                            </li>                        
                                
                            <li>
                                <Link to="/advertisers">Advertisers</Link>
                            </li>    

                            <li>
                                <Link to="/monitoring">Monitoring</Link>
                            </li>    
  
                            <li>
                                <Link to="/technology-scan">Website Profiler</Link>
                            </li>    
                            <li>
                                <Link to="/cve-security-scan">Security Scan</Link>
                            </li>    

                            <li>
                                <Link to="/asn">ASNs</Link>
                            </li>        

                            <li>
                                <Link to="/cve">CVE Vulnerability Database</Link>
                            </li>  

                            <li>
                                <Link to="/cwe">CWEs</Link>
                            </li>  

                            <li>
                                <Link to="/ip-lookup">Reverse IP</Link>
                            </li>  

                            <li>
                                <Link to="/tag">TAG IDs</Link>
                            </li>                                      
                            <li>
                                <Link to="/common-response-headers">HTTP Headers</Link>
                            </li> 
                            <li>
                            </li>  
                        </ul>
                    </div>       
                </div>
                <br/> 
                <br/>                         
                <div className="col-sm-2 col-md-2 col-lg-2" style={{textAlign: 'left'}}>
                    <h4 >Pricing</h4>
                    <div>
                        <ul>
                            <li> 
                                <Link to="/pricing">Plans and Pricing</Link>
                            </li>
                            <li>
                            </li>  
                        </ul>
                    </div>       
                </div>                                             

                <div className="col-sm-1 col-md-1 col-lg-1" style={{textAlign: 'left'}}>
                    <h4 >API</h4>
                    <div>
                        <ul>
                            <li> 
                                <Link 
                                    target="_blank" 
                                    to="/about-api">
                                        API
                                </Link>
                            </li>
                        </ul>
                    </div>       
                </div>                                                              

                <div className="col-sm-2 col-md-2 col-lg-2" style={{textAlign: 'left'}}>
                    <h4 >Resources</h4>
                    <div>
                        <ul>       
                            <li>
                                <Link to="/faq">FAQ</Link>
                            </li>
                            <li>
                                <Link to="/suggest-technology">Suggest technology</Link>
                            </li>                                    
                            <li>
                                <Link to="/domain-removal">Domain removal</Link>
                            </li>     
                            <li>
                            </li>
                        </ul>
                    </div>       
                </div> 
                <br/> 
                <br/>                                          
                <div className="col-sm-2 col-md-2 col-lg-2" style={{textAlign: 'left'}}></div>
                <div className="col-sm-2 col-md-2 col-lg-2" style={{textAlign: 'left'}}>
                    <h4 >Company</h4>
                    <div>
                        <ul>
                            <li> 
                                <Link to="/about-us">About Us</Link>
                            </li>
                            <li>
                                <Link to="/contact-us">Contact Us</Link>
                            </li>                            
                            <li>
                                <Link to="/schedule-demo">Schedule Demo</Link>
                            </li>

                            {
                                true ? 
                                <></>
                                :
                                <li>
                                    <Link to="/blog">Blog</Link>
                                </li>      
                            }

                            <li>
                                <Link to="/bot">Bot</Link>
                            </li>
                            <li>
                            </li>
                        </ul>
                    </div>       
                </div>
            </div>
            <br/>
            <br/>
            <hr/>               
            <div className="row justify-content-left">
                <div className="col-sm-3 col-md-2 col-lg-2">
                    <Link to="/" title='Home' rel="home">
<picture>
    <source srcSet="/s/img/WTSLogoWithText_200_25.png" media="(max-width: 400px)"/>
    <source srcSet="/s/img/WTSLogoWithText_400_50.png" media="(max-width: 800px)"/>
    <source srcSet="/s/img/WTSLogoWithText_medium.png" media="(min-width: 801px)"/>
    <img className="brand-logologo-dark" src="/s/img/WTSLogoWithText_medium.png" width="400" height="50" style={{width:'auto'}}/>
</picture>
                    </Link>          
                </div>
                <div className="col-sm-1 col-md-2 col-lg-2">       
                    <a
                        className="link link-social-1 mdi mdi-facebook" 
                        target="_blank" 
                        rel="noopener nofollow" 
                        href="https://www.facebook.com/WebTechSurvey">
                    </a>
                </div>
                <div className="col-sm-2 col-md-2 col-lg-2">       
                </div>
                <div className="col-sm-3 col-md-2 col-lg-2">
                    <p className="rights"><span>&copy;</span>2025.  All rights reserved.</p>
                    </div>
                <div className="col-sm-3 col-md-2 col-lg-2">
                    <Link 
                        className="link-hover" 
                        to="/privacy" 
                        rel="noopener nofollow"
                    >
                        Privacy Policy
                    </Link>
                    &nbsp;{ ' '}
                    <Link 
                        className="link-hover" 
                        to="/terms" 
                        rel="noopener nofollow"
                    >
                        Terms of Use
                    </Link>
                </div>

            </div>         
        </div>
    </div>
</footer>
	)
} 
